var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"login-main-section",style:({
    backgroundImage:
      'url(https://cdn.trailfinders.com/6stsf6avyp_map3.jpg)',
  })},[_c('div',{staticClass:"grad"},[_c('section',{staticClass:"login-home-page"},[_c('b-container',[_vm._t("default")],2)],1)]),_c('LoadingSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }